import type { FC } from "react";
import * as s from "./Headline.module.scss";

type HeadlineProps = {
	label?: string | null;
	title: string | null;
};

const Headline: FC<HeadlineProps> = ({ label, title }) => (
	<div className={s.headline}>
		{label && <h4 className={s.label}>{label}</h4>}
		{title && <h1 className={s.title}>{title}</h1>}
		<hr className={s.border} />
	</div>
);

export default Headline;
